import React, {useState, useEffect, useRef, useCallback} from "react";
import {mrbgStore, setImgCrop} from './mrbgRedux';
import sectionStyle from '../../static/css/MP_crop.module.css';

function MrbgCropImg(){

  const [cropList,setCropList] = useState(mrbgStore.getState().__CIO);

  useEffect(()=>{
    const unsubscribe = mrbgStore.subscribe(()=>{
      setCropList( mrbgStore.getState().__CIO )
    });
    return () =>unsubscribe();
  },[]);

  return(
    <section id={sectionStyle.up_sec} className={ Object.keys(cropList).length? '': 'disable'}>
      {
        Object.keys(cropList).map((formID,k1)=>{
          return(
            <ul id={`${formID}CropUl`} className={`${sectionStyle.cropUl}${mrbgStore.getState().activeForms.includes(formID+'Frame')? '':' display'}`} key={k1}>
              {
                cropList[formID].imgSrc.map((src,index)=>{
                  return <CropItem {...{formID,index}} key={index}/>
                })
              }
              <li className={sectionStyle.nav_play}>
                <div></div>
                <span>0%</span>
              </li>
            </ul>
          )
        })
      }
    </section>
  )
}
function CropItem({formID,index}){

  const
    frame       = useRef(null ),
    pic         = useRef(null ),
    cover       = useRef( null ),
    dragging = useRef(false),
    preSX    = useRef(false),
    preSY    = useRef(false),
    preTop   = useRef(0),
    preRight = useRef(0),

    [imgSrc,setImgSrc]         = useState( mrbgStore.getState().__CIO[formID].imgSrc[index] ),
    [cropWidth ,setCropWidth ] = useState( mrbgStore.getState().__CIO[formID].cw    [index] ),
    [cropHeight,setCropHeight] = useState( mrbgStore.getState().__CIO[formID].ch    [index] ),
    [zoomRange,setZoomRange] = useState(0),

    [top  ,setTop  ] = useState(0),
    [right,setRight] = useState(0),

    [prePW,setPrePW] = useState(0),
    [prePH,setPrePH] = useState(0),

    [picWidth ,setPicWidth ] = useState(0),
    [picHeight,setPicHeight] = useState(0),

    [xGap,setXGap] = useState(0),
    [yGap,setYGap] = useState(0),

    handleMouseDown = e => {
      if( !e.target.classList.contains(sectionStyle.cropCover) && !e.target.closest(`.${sectionStyle.cropCover}`) )
        return;

      preSX.current    = e.screenX;
      preSY.current    = e.screenY;
      preTop.current   = top;
      preRight.current = right;
      dragging.current = true;
    },
    handleMouseUp   = () => {
      dragging.current = false;
    },
    handleMouseMove = useCallback( e => {
      e.preventDefault();
      if( !dragging.current )
        return;

      setTop  (()=>{
        const dy = e.screenY - preSY.current;
        return Math.max( Math.min(preTop.current+dy, 0), yGap );
      })
      setRight(() => {
        const dx = preSX.current - e.screenX;
        return Math.max( Math.min(preRight.current+dx, 0), xGap )
      });
    },[xGap,yGap,preRight,preTop]);

    function zoomImg( zoomVal ){
      setZoomRange(zoomVal)
      var delta = zoomVal/100+1

      setTop  ( Math.max( Math.min(top-(prePH*delta-picHeight )*0.5,0), cropHeight-prePH*delta ) );
      setRight( Math.max( Math.min(right-(prePW*delta-picWidth)*0.5,0), cropWidth-prePW*delta  ) );

      setPicWidth ( prePW * delta );
      setPicHeight( prePH * delta );

      setXGap( cropWidth  - prePW * delta );
      setYGap( cropHeight - prePH * delta );
    }

    useEffect(()=>{
      if( imgSrc ){
        setZoomRange(0);

        var
          picW,
          picH,
          w,
          h,
          iv = setInterval(()=>{
            if( pic?.current?.src==imgSrc && pic?.current?.complete && pic.current.naturalWidth ){
              clearInterval(iv);

              w = pic.current.naturalWidth;
              h = pic.current.naturalHeight;

              if( w/h > cropWidth/cropHeight ){
                picW = w * cropHeight/h
                picH = parseInt(cropHeight)
              }
              else{
                picW = parseInt(cropWidth)
                picH = h * cropWidth/w;
              }

              setPrePW    ( picW );
              setPrePH    ( picH );
              setPicWidth ( picW );
              setPicHeight( picH );

              setTop      ( (cropHeight - picH)/2 );
              setRight    ( (cropWidth  - picW)/2 );
              setXGap( cropWidth  - picW );
              setYGap( cropHeight - picH );
            }
          },50)
      }
    },[imgSrc]);
    useEffect(()=>{
      cover.current?.addEventListener("mousemove", handleMouseMove);
      cover.current?.addEventListener("mouseleave", handleMouseUp);

      return () => {
        window.removeEventListener("mousemove", handleMouseMove);
        window.removeEventListener("mouseleave", handleMouseUp);
      };
    },[pic.current,handleMouseMove]);
    useEffect(()=>{
      var CIO = JSON.parse(JSON.stringify(mrbgStore.getState().__CIO));
      CIO[formID].cw [index] = cropWidth;
      CIO[formID].ch [index] = cropHeight;
      CIO[formID].iw [index] = picWidth;
      CIO[formID].ih [index] = picHeight;
      CIO[formID].tlx[index] = picWidth - cropWidth - Math.abs(right);
      CIO[formID].tly[index] = Math.abs(top);
      mrbgStore.dispatch(setImgCrop(CIO));
    },[imgSrc,cropWidth,cropHeight,picWidth,picHeight,right,top])
    useEffect(()=>{
      const unsubscribe = mrbgStore.subscribe(()=>{
        setImgSrc    (mrbgStore.getState().__CIO[formID]?.imgSrc[index])
        setCropWidth (mrbgStore.getState().__CIO[formID]?.cw    [index])
        setCropHeight(mrbgStore.getState().__CIO[formID]?.ch    [index])
      });
      return () =>unsubscribe();
    },[]);

  return(
    <li className={sectionStyle.cropLi} ref={frame} style={{height:cropHeight+'px',width:cropWidth+'px'}}>
      <figure className={sectionStyle.cropFig}>
        {
          imgSrc?
            <>
              <img src={imgSrc} ref={pic} style={{height:picHeight,width:picWidth,top:top,right:right}} />
              <div className={sectionStyle.cropCover} ref={cover} onMouseDown={e=>handleMouseDown(e)} onMouseUp={e=>handleMouseUp(e)}></div>
            </>:
            ''
        }
      </figure>
      <input type="range" value={zoomRange} title="move tumb for zoom" onChange={e=>zoomImg(e.target.value)} />
    </li>
  )
}
export default MrbgCropImg;